package pl.nickers.match3.ui

import androidx.compose.material3.lightColorScheme
import androidx.compose.ui.graphics.Color

/**
 * Sepia-ink & parchment palette matching the grimoire art set
 * (see art/grimoire-theme/README.md for the source anchors).
 */
internal object GrimoirePalette {
    val Ink = Color(0xFF43301E)
    val Parchment = Color(0xFFF3E5C2)
    val ParchmentDark = Color(0xFFE4D0A4)
    val Wood = Color(0xFF8A5F30)
    val WoodDark = Color(0xFF5E4222)
    val Gold = Color(0xFFE8B04C)
    val Ember = Color(0xFFD64B33)
    val Forest = Color(0xFF6D8C3E)
    val Cream = Color(0xFFF7ECCE)

    /** Translucent ink-brown for HUD chips sitting on the parchment page. */
    val ChipInk = Color(0xCC4A3620)
}

/** Light Material3 scheme derived from the grimoire palette. */
internal val GrimoireColorScheme = lightColorScheme(
    primary = GrimoirePalette.Wood,
    onPrimary = GrimoirePalette.Cream,
    primaryContainer = Color(0xFFE8D5AE),
    onPrimaryContainer = GrimoirePalette.Ink,
    secondary = GrimoirePalette.Forest,
    onSecondary = GrimoirePalette.Cream,
    secondaryContainer = Color(0xFFDDE8C0),
    onSecondaryContainer = GrimoirePalette.Ink,
    tertiary = GrimoirePalette.Ember,
    onTertiary = GrimoirePalette.Cream,
    background = GrimoirePalette.Parchment,
    onBackground = GrimoirePalette.Ink,
    surface = GrimoirePalette.Parchment,
    onSurface = GrimoirePalette.Ink,
    surfaceVariant = GrimoirePalette.ParchmentDark,
    onSurfaceVariant = GrimoirePalette.WoodDark,
    outline = GrimoirePalette.Wood,
    error = Color(0xFF9C2B1D),
    onError = GrimoirePalette.Cream,
)
